import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-core-header-section-a',
  templateUrl: './core-header-section-a.component.html',
  styleUrls: ['./core-header-section-a.component.scss']
})
export class CoreHeaderSectionAComponent extends BaseComponent implements OnInit {
  @Output() onOpenMobileMenu = new EventEmitter<void>();

  openMobileMenu() {
    this.onOpenMobileMenu.emit();
  }

  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }

  ngOnInit(): void {
  }
}
